var React = require('react');

function EmailIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-email-1{fill:#2d2d2a;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cls-email-1","d":"M285.21,278l86.17,67.14H140.62L226.79,278,248,296.86a12,12,0,0,0,15.92,0ZM118,181.64V332.37l90.52-70.53Zm117.08,71.67L256,271.84l118.53-105h-237l97.59,86.47ZM512,78.39V433.61A78.48,78.48,0,0,1,433.61,512H78.39A78.48,78.48,0,0,1,0,433.61V78.39A78.48,78.48,0,0,1,78.39,0H433.61A78.48,78.48,0,0,1,512,78.39Zm-94,97.45c0-18.2-14.36-33-32-33H126c-17.65,0-32,14.81-32,33V336.16c0,18.2,14.36,33,32,33H386c17.65,0,32-14.81,32-33ZM394,332.37V181.64l-90.52,80.2Z"})))]);
}

EmailIcon.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = EmailIcon;

EmailIcon.default = EmailIcon;
